var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"py-2 bg-dialog text-white m-0 f-14 text-center"},[(_vm.step < 2)?[_vm._v(" Solicitar Cita - Paso "+_vm._s(_vm.step + 1)+" ")]:(_vm.step === 2)?[_vm._v("Mensaje de Validación")]:[_vm._v("Mensaje Informativo")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }